import CheckoutForm from './CheckoutForm'
import {connect} from 'react-redux'
import {
  pageRequest,
  updateSettingRequest
} from 'actions/setting/checkout'
import {browserHistory} from 'react-router'
import {isDirty} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {push} from 'react-router-redux'

class Checkout extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(pageRequest())
      browserHistory.listenBefore((location) => {
        // this is still hacky, don't copy paste this
        if (this.props.isDirtyCheckout && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }
  render () {
    return (<div>
      <CheckoutForm onSubmit={this._onSubmit} />
      <ConfirmActionModal />
    </div>)
  }

  _onSubmit = (values) => {
    let data = {...this.props.data.setting.checkout.setting}
    data.enable_tax = values.tax
    data.enable_gratuity = values.gratuity
    data.include_gratuity_tax = values.includeGratuityTax
    data.track_server = values.trackServer
    this.props.dispatch(updateSettingRequest({settings: data}))
  }
}

Checkout.propTypes = {

}

function mapStateToProps (state) {
  return {
    isDirtyCheckout: isDirty('checkout')(state),
    nextAction: state.confirmAction.nextAction,
    form: state.form,
    data: {
      setting: {
        checkout: state.setting.checkout
      },
      subscriptionExpired: {
        expired: state.subscriptionExpired.expired
      }
    }
  }
}

export default connect(mapStateToProps)(Checkout)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Checkout/Checkout.js